// extracted by css-extract-rspack-plugin
export default {"emptyState":"e9vJ6","empyIcon":"xW0XZ"};